import { useModalContext } from "../../contexts/ModalContext"
import { isMobile } from "react-device-detect"
import share from "../../assets/images/svg/share"

const OpenShareWishesListButton = ({ giftsList }) => {
  const { openWShareWishesListModal } = useModalContext()

  const title = window.document.title
  const url = window.document.location.href

  const handleSharing = () => {
    // Check if the device has access to the webshare api
    if (navigator.share && isMobile) {
      navigator.share({
        title: `${title}`,
        text: `Voici ma liste d'envies :\n${giftsList.map(
          (gift, index) => `\n☞ ${index + 1} : ` + gift.title
        )}\n\nÀ retourver sur : `,
        url: `${url}`,
      }).catch(console.error);
    } else {
      openWShareWishesListModal()
    }
  };

  return (
    <button className="headerBtn" onClick={handleSharing}>
      {share}
    </button>
  )
}

export default OpenShareWishesListButton